enum MovieType {
    movie,
    tv
}

export default MovieType;
